import DashboardsConnection from './DashboardsConnection';

export default DashboardsConnection;
